var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2085 4.07934C11.0782 4.56925 11.7604 5.33445 12.1476 6.25453C12.5348 7.17461 12.6052 8.19733 12.3475 9.16174C12.0898 10.1262 11.5188 10.9775 10.7242 11.5818C9.92969 12.1862 8.95677 12.5091 7.95857 12.5C6.96037 12.4908 5.99356 12.1499 5.21028 11.5311C4.427 10.9122 3.87173 10.0505 3.63185 9.08152C3.39196 8.11253 3.48109 7.09128 3.88519 6.17848C4.28929 5.26569 4.98543 4.51317 5.86406 4.03936",
    stroke: "#00A651",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6967 2.6967C3.39314 2.00026 4.21993 1.44781 5.12987 1.0709C6.03982 0.693993 7.01509 0.5 8 0.5C8.98491 0.5 9.96018 0.693993 10.8701 1.0709C11.7801 1.44781 12.6069 2.00026 13.3033 2.6967C13.9997 3.39314 14.5522 4.21993 14.9291 5.12987C15.306 6.03982 15.5 7.01509 15.5 8C15.5 8.98491 15.306 9.96018 14.9291 10.8701C14.5522 11.7801 13.9997 12.6069 13.3033 13.3033C12.6069 13.9997 11.7801 14.5522 10.8701 14.9291C9.96018 15.306 8.98491 15.5 8 15.5C7.01508 15.5 6.03981 15.306 5.12987 14.9291C4.21993 14.5522 3.39314 13.9997 2.6967 13.3033C2.00026 12.6069 1.44781 11.7801 1.0709 10.8701C0.693993 9.96018 0.5 8.98491 0.5 8C0.5 7.01508 0.693994 6.03981 1.0709 5.12987C1.44782 4.21993 2.00026 3.39314 2.6967 2.6967L2.6967 2.6967Z",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8L8 3",
    stroke: "#00A651",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOff);
export default __webpack_public_path__ + "static/media/off.d9e80e00219f09849105147eb926adcb.svg";
export { ForwardRef as ReactComponent };